"use strict";
/**
 * @fias/platform-resources — Fias-owned static resources served via
 * `cdn.{env}.fias.io`. See `docs/cdn-architecture.md`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.findFamily = exports.VENDORED_FAMILIES = exports.FONT_CATALOG = exports.CATALOG_VERSION = exports.createPlatformResourcesClient = void 0;
var client_1 = require("./client");
Object.defineProperty(exports, "createPlatformResourcesClient", { enumerable: true, get: function () { return client_1.createPlatformResourcesClient; } });
var catalog_1 = require("./catalog");
Object.defineProperty(exports, "CATALOG_VERSION", { enumerable: true, get: function () { return catalog_1.CATALOG_VERSION; } });
Object.defineProperty(exports, "FONT_CATALOG", { enumerable: true, get: function () { return catalog_1.FONT_CATALOG; } });
Object.defineProperty(exports, "VENDORED_FAMILIES", { enumerable: true, get: function () { return catalog_1.VENDORED_FAMILIES; } });
Object.defineProperty(exports, "findFamily", { enumerable: true, get: function () { return catalog_1.findFamily; } });
//# sourceMappingURL=index.js.map